import { render } from "./CreateFees.vue?vue&type=template&id=0f3fdaf8&scoped=true"
import script from "./CreateFees.vue?vue&type=script&lang=js"
export * from "./CreateFees.vue?vue&type=script&lang=js"

import "./CreateFees.vue?vue&type=style&index=0&id=0f3fdaf8&scoped=true&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3fdaf8"]])

export default __exports__